import {
  AUTO_GROW_LAYOUT_REQUEST
} from '../constants/actionTypes';

import { createAction } from 'redux-actions';

export const autoGrowLayout = createAction(AUTO_GROW_LAYOUT_REQUEST, (editorSession, breakpoint, widget, delta) => {
  return {
    editorSession: editorSession,
    breakpoint: breakpoint,
    widget: widget,
    delta: delta
  };
});
